import { Field } from 'formik';
import type { FieldProps } from 'formik';

import { ProcessSelector } from 'modules/common/smartComponents';

import type { FormData } from '../types';
import { HorizontalFormControl } from './HorizontalFormControl';

export const HasProcessFilter = () => {
  return (
    <HorizontalFormControl label="Has Process">
      <Field name="processIn">
        {({ field, form }: FieldProps<FormData['processIn'], FormData>) => (
          <ProcessSelector
            allowMultiSelect={true}
            onChange={(value) => form.setFieldValue(field.name, value)}
            selectedValues={field.value}
          />
        )}
      </Field>
    </HorizontalFormControl>
  );
};
